var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 34265"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.08752 2.00474L1.86632 8.22594C1.62658 8.46568 1.39884 8.93317 1.35089 9.2688L1.01526 11.6422C0.895389 12.5053 1.49473 13.1046 2.35779 12.9847L4.73117 12.6491C5.0668 12.6012 5.53432 12.3734 5.77406 12.1337L11.9953 5.91247C13.0621 4.84563 13.5775 3.599 11.9953 2.01673C10.413 0.422468 9.16634 0.92592 8.08752 2.00474Z",
    stroke: "#0008C3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.19531 2.89258C7.72274 4.77452 9.19712 6.2609 11.0911 6.78832",
    stroke: "#0008C3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.dbb6644cfd52b27cb1b46ca73c4913b3.svg";
export { ForwardRef as ReactComponent };